import React, { useState } from 'react'
import { List, ListItemText, Paper, ListItem, ListItemSecondaryAction, IconButton,  makeStyles, InputAdornment } from '@material-ui/core';
import DeleteTwoToneIcon from '@material-ui/icons/DeleteTwoTone';
import { roundTo2DecimalPoint } from "../../utils";
import { Input, Select, Button } from "../../controls";
import { ButtonGroup, Button as MuiButton } from '@material-ui/core';
import ReplayIcon from '@material-ui/icons/Replay';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';

import Notification from "../../layouts/Notification";

const useStyles = makeStyles(theme => ({
    paperRoot: {
        margin: '15px 0px',
        '&:hover': {
            cursor: 'pointer'
        },
        '&:hover $deleteButton': {
            display: 'block'
        }
    },
    buttonGroup: {
        backgroundColor: '#E3E3E3',
        borderRadius: 8,
        '& .MuiButtonBase-root ': {
            border: 'none',
            minWidth: '25px',
            padding: '1px'
        },
        '& button:nth-child(2)': {
            fontSize: '1.2em',
            color: '#000'
        }
    },
    deleteButton: {
        display: 'none',
        '& .MuiButtonBase-root': {
            color: '#E81719'
        },
    },
    totalPerItem: {
        fontWeight: 'bolder',
        fontSize: '1.2em',
        margin: '0px 10px',
        color: '#6666ff'
    },
    totalPerItem2: {
        fontWeight: 'bolder',
        fontSize: '1.0em',
        margin: '0px 10px',
        color: '#6666ff'
    },
    totalPerItem3: {
        fontWeight: 'bolder',
        fontSize: '1.2em',
        margin: '0px 10px',
        color: '#5dc1b9'
    },
    tamanoInput: {
        width: '100px',
        color: '#6666ff'
    },
    cantidaditem: {
        color: '#6666ff'
    },
    tamanoSelect: {
        minWidth: '220px'
    }
}))

const ajusteOpciones = [
    { id: 'none', title: '' },
    { id: 'Sumar', title: 'Sumar' },
    { id: 'Restar', title: 'Restar' },
]



export default function OrderedFoodItems(props) {

    const [notify, setNotify] = useState({ isOpen: false });

    const { values, setValues, errors, setErrors, handleInputChange } = props;
    const classes = useStyles();

    let orderedFoodItems = values.orderDetails;

    const removeFoodItem = (index, id) => {
        //debugger;
        let x = { ...values };
        x.orderDetails = x.orderDetails.filter((_, i) => i != index);
        if (id != 0) x.deletedOrderItemIds += id + ',';
        setValues({ ...x });
    }//END METHOD

    const updateQuantity = (idx, value) => {
        //debugger;
        let x = { ...values };
        let foodItem = x.orderDetails[idx];
        if (foodItem.quantity + value > 0) {
            foodItem.quantity += value;
            setValues({ ...x });
        }
    }//END METHOD

    const ejecutarAjuste = (idx) => {
        //debugger;
        let x                   = { ...values };
        let foodItem            = x.orderDetails[idx];

        let _tipoajuste         = x.tipoajuste;
        let _ajuste             = parseFloat(values.ajuste);
        let _motivoajuste       = values.motivoajuste;



        if (_tipoajuste === "none") {
            setNotify({ isOpen: true, message: '¡Debes definir el tipo de ajuste!' });
            return;
        }

        if (_ajuste === 0) {
            setNotify({ isOpen: true, message: '¡El monto del ajuste debe ser mayor a cero!' });
            return;
        }

        if (_motivoajuste.length === 0) {
            setNotify({ isOpen: true, message: '¡Debes ingresar motivo ajuste!' });
            return;
        }  

        foodItem.tipoajuste     = _tipoajuste;
        foodItem.ajuste         = _ajuste;
        foodItem.motivoajuste   = _motivoajuste; 

        setValues({ ...x });

    }//END METHOD
    

    return (
        <>
             


            <List>
                {orderedFoodItems.length == 0 ?
                    <ListItem>
                        <ListItemText
                            primary="Por favor, seleccione algún servicio o colegiatura"
                            primaryTypographyProps={{
                                style: {
                                    textAlign: 'center',
                                    fontStyle: 'italic'
                                }
                            }}
                        />
                    </ListItem>
                    : orderedFoodItems.map((item, idx) => (
                        <Paper key={idx} className={classes.paperRoot}>
                            <ListItem>
                                <ListItemText
                                    primary={item.foodItemName}
                                    primaryTypographyProps={{
                                        component: 'h1',
                                        style: {
                                            fontWeight: '500',
                                            fontSize: '1.2em'
                                        }
                                    }}
                                    secondary={
                                        <>

                                            <ButtonGroup className={classes.buttonGroup} size="small">
                                                <span className={classes.totalPerItem2}>{item.tipoajuste + ' ' + '$' + item.ajuste + ' / ' + item.motivoajuste} <br/></span>

                                                <Button onClick={e => updateQuantity(idx, -1)}>-</Button>
                                                <Button disabled>
                                                    <span className={classes.cantidaditem}>
                                                        {item.quantity}    
                                                    </span>
                                                </Button>
                                                <Button onClick={e => updateQuantity(idx, 1)}>+</Button>
                                            </ButtonGroup>

                                            <Select
                                                label="Tipo"
                                                name="tipoajuste"
                                                value={values.tipoajuste}
                                                onChange={handleInputChange}
                                                options={ajusteOpciones}
                                                error={errors.tipoajuste}
                                                className={classes.tamanoSelect}
                                            />

                                            <Input
                                                className={classes.tamanoInput}
                                                label="Ajuste"
                                                name="ajuste"
                                                value={values.ajuste}
                                                onChange={handleInputChange}
                                                error={errors.ajuste}
                                                InputProps={{
                                                    startAdornment: <InputAdornment
                                                        className={classes.adornmentText}
                                                        position="start">$</InputAdornment>
                                                }}
                                                type="number"
                                            />

                                            <Input
                                                label="Motivo Ajuste"
                                                name="motivoajuste"
                                                value={values.motivoajuste}
                                                onChange={handleInputChange}
                                                error={errors.motivoajuste}
                                                type="text"
                                            />


                                            <MuiButton
                                                size="small"
                                                startIcon={<CurrencyExchangeIcon />}
                                                onClick={e => ejecutarAjuste(idx)}
                                            />

                                                <span className={classes.totalPerItem}>
                                                    {'$' + roundTo2DecimalPoint(item.quantity * item.foodItemPrice)}
                                                </span>

                                                <span className={classes.totalPerItem3}>
                                                    (
                                                {'$' + roundTo2DecimalPoint((item.tipoajuste == "Sumar") ? (item.quantity * item.foodItemPrice + item.ajuste) : (item.quantity * item.foodItemPrice - item.ajuste))}
                                                )
                                            </span>





                                        </>
                                    }
                                    secondaryTypographyProps={{
                                        component: 'div'
                                    }}
                                />


                                <ListItemSecondaryAction
                                    className={classes.deleteButton}>
                                    <IconButton
                                        disableRipple
                                        onClick={e => removeFoodItem(idx, item.orderDetailId)}
                                    >
                                        <DeleteTwoToneIcon />
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </ListItem>
                        </Paper>
                    ))
                }
            </List>

            <Notification
                {...{ notify, setNotify }} />

        </>

    )
}
